<template>
  <HeadlessTransitionRoot
    appear
    :show="isOpen"
    as="template"
  >
    <HeadlessDialog
      as="div"
      class="relative z-50"
      @close="emit('close')"
    >
      <HeadlessTransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25">
          <MouseFollower :hide-when-over-el="dialogPanelEl" />
        </div>
      </HeadlessTransitionChild>

      <div class="fixed bottom-0 left-0 top-0 w-screen overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-5 text-center">
          <HeadlessTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <HeadlessDialogPanel class="w-full max-w-4xl rounded-2xl shadow-xl transition-all">
                <div class="flex rounded-2xl bg-whitegray p-4 flex-col sm:flex-row sm:p-10">
                  <div class="flex flex-col gap-4 flex-1 flex-grow">
                      <h1 class="mb-2 w-full text-center font-medium text-2xl ">Изменилась цена доставки</h1>

                      <div>Новая цена доставки: {{deliveryPrice}}&nbsp;&#8381;</div>

                      <h3 class="mb-2">Продолжить оформление заказа?</h3>

                      <div>
                          <SimpleButton
                              class="mt-4 px-4 py-4 uppercase"
                              type="button"
                              @click="emit('proceedCheckout')"

                          >
                              Да, продолжить
                          </SimpleButton>

                          <SimpleButton
                              class="mt-4 ml-4 px-4 py-4 uppercase"
                              type="button"
                              theme="grey"
                              @click="emit('close')"
                          >
                              Нет
                          </SimpleButton>
                      </div>
                  </div>
                  </div>
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
    isOpen?: boolean
    deliveryPrice?: number
}>()
const { isOpen, deliveryPrice } = toRefs(props)
const emit = defineEmits(['proceedCheckout', 'close'])

const dialogPanelEl = ref<HTMLElement>()

</script>
